<template>
  <v-dialog
    v-model="props.dialog_parent"
    max-width="750px"
    v-on:click:outside="closeDialogChild"
  >
    <v-card>
      <v-card-title class="bg-blue-darken-2">
        <h2 class="text-h4 text-center">Dotación Pistola</h2>
      </v-card-title>

      <v-card-title>
        <span class="text-h5">
          <v-icon
            icon="mdi-pencil"
            size="samll"
            color="blue-darken-2 as-scale"
          ></v-icon>
          {{ props.formTitleParent }}
        </span>
      </v-card-title>

      <v-container>
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="props.registro_parent.carnet"
              color="cyan-darken-2"
              label="Carnet"
              :rules="[
                () => !!props.registro_parent.carnet || required_message,
                (v) =>
                  !!/^\d+$/.test(v) ||
                  'El Numero de identidad solo debe contener caracteres numéricos.',
              ]"
              :error-messages="getValidationErrors('carnet')"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="2">
            <v-btn color="blue" @click="buscarNombre">Buscar</v-btn>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="props.registro_parent.nro_pistola"
              color="cyan-darken-2"
              label="# Arma Serie"
              :rules="[
                () => !!props.registro_parent.nro_pistola || required_message,
              ]"
              :error-messages="getValidationErrors('nro_pistola')"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="2">
            <v-btn color="blue" @click="buscarArma">Buscar</v-btn>
          </v-col>
<v-col cols="12">
  <v-divider></v-divider>
            <v-card-title>Datos del Personal Militar</v-card-title>
</v-col>
            <v-col cols="12" md="3">
            <v-select
              v-model="props.registro_parent.grado"
              :items="gradosselect"
              color="cyan-darken-1"
              label="Grado"
              variant="outlined"
            ></v-select>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="props.registro_parent.nombres"
              color="cyan-darken-1"
              label="Nombres"
              variant="outlined"
              disabled
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="props.registro_parent.apellido_paterno"
              color="cyan-darken-1"
              label="Primer Apellido"
              variant="outlined"
              disabled
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="props.registro_parent.apellido_materno"
              color="cyan-darken-1"
              label="Segundo Apellido"
              variant="outlined"
              disabled
            ></v-text-field>
          </v-col>
          <!-- <v-col cols="12" md="9">
            <v-text-field
              v-model="props.registro_parent.nombreCompletolimpio"
              color="cyan-darken-1"
              label="Nombre"
              variant="outlined"
              disabled
            ></v-text-field>
          </v-col> -->
          <v-col cols="12" md="4">
            <v-text-field
              v-model="props.registro_parent.codigo_persona"
              color="cyan-darken-2"
              label="Codigo Persona"
              variant="outlined"
              disabled
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="props.registro_parent.carnet"
              color="cyan-darken-2"
              label="Carnet"
              variant="outlined"
              disabled
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="2">
            <v-text-field
              v-model="props.registro_parent.complemento"
              color="cyan-darken-2"
              label="Complemento"
              variant="outlined"
              disabled
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="2">
            <v-text-field
              v-model="props.registro_parent.expedido"
              color="cyan-darken-2"
              label="Expedido"
              variant="outlined"
              disabled
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-select
              v-model="props.registro_parent.instituto_militar"
              :items="selectinstituto"
              color="cyan-darken-2"
              label="Instituto Militar"
              variant="outlined"
            ></v-select>
          </v-col>
          <v-col cols="12" md="6">
            <v-select
              v-model="props.registro_parent.fuerza"
              :items="selectfuerza"
              color="cyan-darken-2"
              label="Fuerza"
              variant="outlined"
            ></v-select>
          </v-col>
          <v-col cols="12" md="6">
            <v-select
              v-model="props.registro_parent.gestion_egreso"
              :items="selectgestionegreso"
              color="cyan-darken-2"
              label="Gestion Egreso"
              variant="outlined"
            ></v-select>
          </v-col>
          
          <v-divider></v-divider>
          <v-card-title>Datos del Arma</v-card-title>
          <v-col cols="12" md="12">
            <v-text-field
              v-model="props.registro_parent.nro_pistola"
              color="cyan-darken-2"
              label="Arma Serie"
              variant="outlined"
              disabled
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="3">
            <v-text-field
              v-model="props.registro_parent.marca"
              color="cyan-darken-2"
              label="Marca"
              variant="outlined"
              disabled
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="props.registro_parent.modelo"
              color="cyan-darken-2"
              label="Modelo"
              variant="outlined"
              disabled
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="props.registro_parent.calibre"
              color="cyan-darken-2"
              label="Calibre"
              variant="outlined"
              disabled
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="props.registro_parent.num_cargadores"
              color="cyan-darken-2"
              label="Cant. Cargadores"
              variant="outlined"
              disabled
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="props.registro_parent.procedencia"
              color="cyan-darken-2"
              label="Procedencia"
              variant="outlined"
              disabled
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="props.registro_parent.clasificacion"
              color="cyan-darken-2"
              label="Clasificacion"
              variant="outlined"
              disabled
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="props.registro_parent.observaciones"
              color="cyan-darken-2"
              label="Observaciones"
              variant="outlined"
              disabled
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="props.registro_parent.status"
              label="Estado"
              variant="outlined"
              disabled
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-select
              v-model="props.registro_parent.gestion_dotacion"
              :items="items"
              density="compact"
              label="Gestión Dotacion"
            ></v-select>
          </v-col>
<!--           <v-col cols="12" md="3">
            <v-text-field
              v-model="props.registro_parent.codigo_dotacion"
              color="cyan-darken-2"
              label="Codigo Dotacion"
              variant="outlined"
            ></v-text-field>
          </v-col> -->
        </v-row>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn variant="outlined" @click="closeDialogChild()" color="red">
          <v-icon icon="mdi-file-cancel-outline"></v-icon>&nbsp;Cancelar
        </v-btn>
        <v-btn color="cyan-darken-1" variant="outlined" @click="saveChild()">
          <v-icon icon="mdi-content-save-check-outline"></v-icon>&nbsp;Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { defineComponent } from "vue";
import Busqueda from "@/services/Personal";
import BusquedaArma from "@/services/Armas";

export default defineComponent({
  props: [
    "dialog_parent",
    "registro_parent",
    "formTitleParent",
    "errors_validate_parent",
  ],
  emits: ["closeDialogParent", "saveParent"],
  data: () => ({
    items: ["2021", "2022", "2023", "2024"],
    gradosselect:['Gral.','Cnl.','Tcnl.','My.','Cap.','Tte.','Sbtte','Sofs.','Sof.Mtre.','Sof.My.','Sof.1ro.','Sof.2do','Sof.Inc.','Sgto.1ro.','Sgto.2do.','Sgto.Inc.'],
    selectinstituto:['EMT EJ TCNL. JUAN ONDARZA LARA','EMME EJ TCNL. ADRIAN PATIÑO CARPIO','PMA SBTTE J.M.ARDILES M.','ESAA SG2 REYNALDO ZEBALLOS JOFFRE',
                      'EMSE SGTO.MAXIMILIANO PAREDES','COL.MIL.TGRAL.GERMAN BUSCH BECERRA','ENM EDUARDO AVAROA HIDALGO','COL.MIL.CNL.GUALBERTO VILLARROEL',
                    'EMM.SGTO.MY.JOSE SANTOS VARGAS'],
    selectfuerza:['EJERCITO','FUERZA AEREA','FUERZA ARMADA'],
    selectgestionegreso:['1970','1971','1972','1973','1974','1975','1976','1977',
                        '1978','1979','1980','1981','1982','1983','1984','1985',
                        '1986','1987','1988','1989','1990','1991','1992','1993',
                        '1994','1995','1996','1997','1998','1999','2000','2001',
                        '2002','2003','2004','2005','2006','2007','2008','2009',
                        '2010','2011','2012','2013','2014','2015','2016','2017',
                        '2018','2019','2020','2021','2022','2023','2024','2025',
                        '2026','2027','2028','2029','2030','2031','2032','2033',
                        '2034','2035'],
    }),
  methods: {
    async buscarNombre() {
      try {
        const numeroCarnet = this.props.registro_parent.carnet;
        console.log("Número de Carnet:", numeroCarnet);

        const busqueda = new Busqueda();
        const resultadoBusqueda = await busqueda.busquedaporci(numeroCarnet);
        console.log("Resultado de la búsqueda:", resultadoBusqueda);
        //resultadoBusqueda && resultadoBusqueda.status && resultadoBusqueda.records &&
        if (
          resultadoBusqueda &&
          resultadoBusqueda.status &&
          resultadoBusqueda.records &&
          resultadoBusqueda.records.data &&
          resultadoBusqueda.records.data.nombre
        ) {
          this.props.registro_parent.nombreCompletolimpio =
            resultadoBusqueda.records.data.nombre;
          this.props.registro_parent.codigo_persona =
            resultadoBusqueda.records.data.codigo_persona;
            this.props.registro_parent.grado =
            resultadoBusqueda.records.data.grado;
            this.props.registro_parent.nombres =
            resultadoBusqueda.records.data.nombres;
            this.props.registro_parent.apellido_paterno =
            resultadoBusqueda.records.data.apellido_paterno;
            this.props.registro_parent.apellido_materno =
            resultadoBusqueda.records.data.apellido_materno;
            this.props.registro_parent.complemento =
            resultadoBusqueda.records.data.complemento;
            this.props.registro_parent.expedido =
            resultadoBusqueda.records.data.expedido;
          console.log(
            "Este es el nombre completo",
            this.props.registro_parent.nombreCompletolimpio
          );
        } else {
          alert(
            "Carnet no encontrado en la base de datos o no hay un nombre disponible en la respuesta"
          );
        }
      } catch (error) {
        console.error(error);
      }
    },
    async buscarArma() {
      try {
        const codigoarma = this.props.registro_parent.nro_pistola;
        console.log("Codigo del Arma", codigoarma);

        const busqueda = new BusquedaArma();
        const resultadoBusqueda = await busqueda.busquedaporcodigoarmadetalle(
          codigoarma
        );
        console.log("Resultado de la búsqueda del Arma:", resultadoBusqueda);

        if (
          resultadoBusqueda &&
          resultadoBusqueda.status &&
          resultadoBusqueda.data &&
          resultadoBusqueda.data.nro_pistola
        ) {
          const primerRegistro = resultadoBusqueda.data;

          this.props.registro_parent.nro_pistola = primerRegistro.nro_pistola;
          this.props.registro_parent.marca = primerRegistro.marca;
          this.props.registro_parent.modelo = primerRegistro.modelo;
          this.props.registro_parent.calibre = primerRegistro.calibre;
          this.props.registro_parent.num_cargadores =
            primerRegistro.num_cargadores;
          this.props.registro_parent.procedencia = primerRegistro.procedencia;
          this.props.registro_parent.clasificacion =
            primerRegistro.clasificacion;
          this.props.registro_parent.observaciones =
            primerRegistro.observaciones;
          this.props.registro_parent.status = primerRegistro.status;

          console.log(
            "Este es el código del arma",
            this.props.registro_parent.nro_pistola
          );
          console.log(
            "Este es el código de la marca",
            this.props.registro_parent.marca_arma
          );
        } else {
          alert("Código de Arma no encontrada");
        }
        console.log("Respuesta completa del servicio:", resultadoBusqueda);
      } catch (error) {
        console.error(error);
      }
    },
  },
  setup(props, { emit }) {
    const closeDialogChild = () => {
      emit("closeDialogParent");
    };
    const saveChild = () => {
      emit("saveParent");
    };
    return { props, closeDialogChild, saveChild };
  },
  computed: {
    getValidationErrors() {
      return function (property) {
        if (
          this.props.errors_validate_parent &&
          this.props.errors_validate_parent[property]
        ) {
          return this.props.errors_validate_parent[property][0];
        }
        return "";
      };
    },
  },
});
</script>
